import { focusFirstAvailableSeat } from '../../../utils/SeatMapMainContentUtils';
export const fadeVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: 'easeInOut'
    }
  }
};
export const useTravelerButton = _ref => {
  let {
    travelerId,
    activeTraveler,
    selectedSeat,
    onChange,
    setTravelerButtonWithRemoveLink
  } = _ref;
  const isActive = travelerId === activeTraveler;
  const handleClick = e => {
    var _onChange;
    onChange === null || onChange === void 0 || (_onChange = onChange(travelerId)) === null || _onChange === void 0 || _onChange(e);
    setTravelerButtonWithRemoveLink(selectedSeat ? travelerId : undefined);
    focusFirstAvailableSeat();
  };
  const handleFocus = () => setTravelerButtonWithRemoveLink(travelerId);
  return {
    handleClick,
    handleFocus,
    isActive
  };
};
//# sourceMappingURL=useTravelerButton.js.map